<template>
  <div class="block">
    <div
      :class="{
        previous: true,
        hidden: first
      }"
      @click="handlePreviousClick()"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="39"
        viewBox="0 0 20 39"
        class="blocksvg"
      >
        <path
          fill="#c04323"
          d="M20 19.5L0 39 0 26.148 6.817 19.5 0 12.853 0 0z"
        />
      </svg>
    </div>
    <div class="text" v-if="step.text !== 'last-step'" v-html="step.text"></div>
    <div
      class="text"
      v-if="step.text === 'last-step' && !$store.state.isMobile"
    >
      <div class="controls-guide">
        <div class="guide">
          Use <span class="copper">←</span> and <span class="copper">→</span> to
          drive <span class="bold">left</span> and
          <span class="bold">right</span>
        </div>
        <div class="guide">
          <span class="copper">↑</span> and <span class="copper">↓</span> to
          <span class="bold">change years</span>
        </div>
        <div class="guide">
          <span class="copper">[space]</span> to
          <span class="bold">flip</span> to other side of street
        </div>
        <div class="start-driving" @click="startDriving()">
          Start driving
        </div>
        <div
          class="restart"
          @click="$store.dispatch('goToLocation', { target: steps[0].start })"
        >
          Back to start
        </div>
      </div>
    </div>
    <div class="text" v-if="step.text === 'last-step' && $store.state.isMobile">
      <div class="controls-guide">
        <div class="guide">
          Swipe <span class="copper">←</span> and
          <span class="copper">→</span> to drive
          <span class="bold">left</span> and
          <span class="bold">right</span>
        </div>
        <div class="start-driving" @click="$emit('exitNarrative')">
          Start driving
        </div>
        <div
          class="restart"
          @click="$store.dispatch('goToLocation', { target: steps[0].start })"
        >
          Back to start
        </div>
      </div>
    </div>
    <div :class="{ next: true, hidden: last }" @click="handleNextClick">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="39"
        viewBox="0 0 20 39"
        class="blocksvg"
      >
        <path
          fill="#c04323"
          d="M20 19.5L0 39 0 26.148 6.817 19.5 0 12.853 0 0z"
        />
      </svg>
    </div>
    <div
      v-if="!last"
      class="restart restart-start"
      @click="$emit('exitNarrative')"
    >
      EXIT
    </div>
    <div class="card-number">{{ step.index + 1 + " of " + total }}</div>
    <div
      class="progress"
      :style="{
        'max-width': '100%',
        width: progress * 100 + '%'
      }"
    />
  </div>
</template>

<script>
import { stepLength, steps } from "../constants/narrative.js";

export default {
  name: "NarrativeBlock",
  props: {
    step: Object,
    first: Boolean,
    last: Boolean,
    total: Number,
    progress: Number
  },
  computed: {
    jumping() {
      return this.$store.state.geolocation.jumping;
    },

    steps() {
      return steps;
    }
  },
  methods: {
    handlePreviousClick() {
      if (this.jumping) return;
      if (!this.first) {
        this.$store.dispatch("goToLocation", {
          target: this.step.start + stepLength * -0.5
        });
      }
    },

    handleNextClick() {
      if (this.jumping) return;
      this.$store.dispatch("goToLocation", { target: this.step.end - 0.00001 });
    },

    startDriving() {
      this.$store.dispatch("openRidePicker");
      this.$emit("exitNarrative");
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/constants/_variables.scss";

.block {
  background-color: $very-light-pink;
  padding: 3em 1em;
  width: 711px;
  height: 243px;
  position: absolute;
  z-index: 100;
  top: calc(50% - 243px + 33.5px - 5px - 10px);
  left: calc(50% - 356px);

  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 18px;
  line-height: 1.5;
  text-align: left;

  @media (max-width: 815px) {
    width: calc(100% - 100px);
    height: 180px;
    left: 50px;
    top: calc(50% - 90px);
    font-size: 15px;
    padding: 1em 1em;
  }

  @media (max-width: 815px) and (orientation: portrait) {
    height: 350px;
    top: calc(50% - 175px);
    width: calc(100% - 50px);
    left: 25px;
  }

  .text::first-letter {
    font-style: italic;
    font-size: 60px;
    color: $copper;
    float: left;
    font-weight: bold;
    line-height: 0.8;
    margin-right: 0.1em;

    @media (max-width: 815px) {
      font-size: 52px;
    }
  }

  .progress {
    position: absolute;
    bottom: -5px;
    left: 0px;
    height: 5px;
    background-color: $copper;
  }

  .previous {
    transform: scaleX(-1);
    margin-right: 2em;

    @media (max-width: 815px) {
      margin-right: 0.5em;
    }
  }

  .next {
    margin-left: 2em;

    @media (max-width: 815px) {
      margin-left: 0.5em;
    }
  }

  .next,
  .previous {
    cursor: pointer;

    &.hidden {
      opacity: 0;
      cursor: default;
    }
  }
}
</style>

<style lang="scss">
@import "@/constants/_variables.scss";

.highlight {
  background-color: $light-gold;
  color: $copper;
}

.guide {
  text-align: center;
}

.controls-guide {
  width: 563px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  height: 200px;

  @media (max-width: 815px) {
    height: 120px;
  }

  &::first-letter {
    font-style: normal;
    font-size: 18px;
    color: black;
    float: none;
    font-weight: normal;
    line-height: 1;
    margin-right: 0em;
  }
}

.start-driving {
  background-color: $copper;
  color: $white;
  font-style: italic;
  padding: 0.25em 0.5em;
  text-transform: uppercase;
  font-weight: 500;
  cursor: pointer;

  &:hover {
    background-color: $light-gold;
    color: $copper;
  }
}

.restart {
  font-size: 15px;
  text-decoration: underline;
  color: $copper;
  text-transform: uppercase;
  cursor: pointer;

  &:hover {
    color: black;
  }
}

.read {
  font-weight: bold;
  font-style: italic;
}

.copper {
  color: $copper;
}

.bold {
  font-weight: 600;
}

.restart-start {
  position: absolute;
  right: 10px;
  top: 10px;
}

.card-number {
  color: $brown-grey;
  position: absolute;
  bottom: 10px;
  right: 10px;
  font-size: 14px;
}

svg.blocksvg:hover path {
  fill: $light-gold !important;
}
</style>
